<template>
    <section id="add_credit" class="add_credit">
        <div class="top_section">
            <h1 class="font-apercu-bold is-size-4">{{ $t("Transactions") }}</h1>
            <div style="margin: 0 45px; display: flex; align-items: center">
                <div class="balance is-size-4">
                    <img src="../assets/images/logo.png" alt />

                    <span style="color: #12d684">{{
                        userData.balance | currency("")
                    }}</span>
                    <span class="font-10" style="color: #000">{{
                        $t("SAR")
                    }}</span>
                </div>
            </div>
        </div>
        <div id="main-card">
            <div class="card-head">
                <div class="l-sec">
                    <div
                        style="
                            width: 100%;
                            display: flex;
                            justify-content: center;
                        "
                    >
                        <input
                            type="text"
                            v-model="search"
                            :placeholder="$t('Search with Transaction Id')"
                        />
                    </div>
                </div>
                <div class="r-sec">
                    <div>
                        <button
                            class="button add-credit"
                            @click="showAddCredit = true"
                        >
                            <span
                                style="
                                    font-size: 14px;
                                    font-weight: lighter !important;
                                "
                                >{{ $t("Add credit") }}</span
                            >
                        </button>
                        <export-excel
                            :title="$t('ALKOON Transactions')"
                            class="d-sm-none"
                            :fields="json_fields"
                            :data="transactions"
                            :before-finish="resetIndex"
                            worksheet="ALKOON Transactions"
                            name="ALKOON_Transactions.xls"
                        >
                            <button class="button">{{ $t("Export") }}</button>
                        </export-excel>
                    </div>
                </div>
            </div>
            <div
                class="table"
                v-if="filterdTransaction && filterdTransaction.length"
            >
                <b-table
                    :loading="loading"
                    :data="filterdTransaction"
                    :paginated="isPaginated"
                    backend-pagination
                    :per-page="perPage"
                    :total="totalTransactions"
                    :current-page.sync="currentPage"
                    :pagination-simple="isPaginationSimple"
                    :pagination-position="paginationPosition"
                    :default-sort-direction="defaultSortDirection"
                    :sort-icon="sortIcon"
                    :sort-icon-size="sortIconSize"
                    @page-change="filterTransaction($event)"
                    :aria-next-label="$t('Next page')"
                    :aria-previous-label="$t('Previous page')"
                    :aria-page-label="$t('Page')"
                    :aria-current-label="$t('Current page')"
                >
                    <template slot-scope="props">
                        <b-table-column
                            field="id"
                            :label="$t('Bank account')"
                            sortable
                            width="200"
                            >{{ props.row.bank }}</b-table-column
                        >

                        <b-table-column
                            field="date"
                            :label="$t('Transaction date')"
                            sortable
                            :centered="false"
                            width="200"
                        >
                            {{
                                props.row.transaction_date
                                    | moment("DD MMM YYYY")
                            }}
                        </b-table-column>

                        <b-table-column
                            field="date"
                            :label="$t('Requedst date')"
                            sortable
                            :centered="false"
                            width="200"
                        >
                            {{ props.row.created_at | moment("DD MMM YYYY") }}
                        </b-table-column>

                        <b-table-column
                            field="date"
                            :label="$t('Status')"
                            sortable
                            :centered="false"
                            width="200"
                        >
                            <span :class="'status st-' + props.row.status">
                                {{ $t(props.row.status) }}
                            </span>
                        </b-table-column>

                        <b-table-column
                            :class="[
                                props.row.amount > 1 ? 'primary' : 'danger',
                            ]"
                            field="credit"
                            :label="$t('Amount')"
                            sortable
                            :centered="false"
                            width="200"
                        >
                            {{ props.row.amount | currency("") }}
                            SAR
                        </b-table-column>

                        <b-table-column
                            field="order_id"
                            :label="$t('Transaction id')"
                            sortable
                            :centered="false"
                            width="250"
                            >{{ props.row.transaction_id }}</b-table-column
                        >
                        <b-table-column
                            field="description"
                            :label="$t('Transaction file')"
                            :centered="false"
                            sortable
                        >
                            <div class="images" v-viewer="options">
                                <span
                                    class="pointer"
                                    @click="
                                        $refs[
                                            'img' + props.row.transaction_id
                                        ].click()
                                    "
                                >
                                    <svg
                                        height="20"
                                        viewBox="-27 0 512 512"
                                        width="20"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="m188 492c0 11.046875-8.953125 20-20 20h-88c-44.113281 0-80-35.886719-80-80v-352c0-44.113281 35.886719-80 80-80h245.890625c44.109375 0 80 35.886719 80 80v191c0 11.046875-8.957031 20-20 20-11.046875 0-20-8.953125-20-20v-191c0-22.054688-17.945313-40-40-40h-245.890625c-22.054688 0-40 17.945312-40 40v352c0 22.054688 17.945312 40 40 40h88c11.046875 0 20 8.953125 20 20zm117.890625-372h-206c-11.046875 0-20 8.953125-20 20s8.953125 20 20 20h206c11.042969 0 20-8.953125 20-20s-8.957031-20-20-20zm20 100c0-11.046875-8.957031-20-20-20h-206c-11.046875 0-20 8.953125-20 20s8.953125 20 20 20h206c11.042969 0 20-8.953125 20-20zm-226 60c-11.046875 0-20 8.953125-20 20s8.953125 20 20 20h105.109375c11.046875 0 20-8.953125 20-20s-8.953125-20-20-20zm355.472656 146.496094c-.703125 1.003906-3.113281 4.414062-4.609375 6.300781-6.699218 8.425781-22.378906 28.148437-44.195312 45.558594-27.972656 22.324219-56.757813 33.644531-85.558594 33.644531s-57.585938-11.320312-85.558594-33.644531c-21.816406-17.410157-37.496094-37.136719-44.191406-45.558594-1.5-1.886719-3.910156-5.300781-4.613281-6.300781-4.847657-6.898438-4.847657-16.097656 0-22.996094.703125-1 3.113281-4.414062 4.613281-6.300781 6.695312-8.421875 22.375-28.144531 44.191406-45.554688 27.972656-22.324219 56.757813-33.644531 85.558594-33.644531s57.585938 11.320312 85.558594 33.644531c21.816406 17.410157 37.496094 37.136719 44.191406 45.558594 1.5 1.886719 3.910156 5.300781 4.613281 6.300781 4.847657 6.898438 4.847657 16.09375 0 22.992188zm-41.71875-11.496094c-31.800781-37.832031-62.9375-57-92.644531-57-29.703125 0-60.84375 19.164062-92.644531 57 31.800781 37.832031 62.9375 57 92.644531 57s60.84375-19.164062 92.644531-57zm-91.644531-38c-20.988281 0-38 17.011719-38 38s17.011719 38 38 38 38-17.011719 38-38-17.011719-38-38-38zm0 0"
                                        />
                                    </svg>
                                </span>
                                <img
                                    :ref="'img' + props.row.transaction_id"
                                    style="display: none"
                                    v-bind:src="
                                        'data:image/jpeg;base64,' +
                                        props.row.attached_file
                                    "
                                />
                            </div>
                        </b-table-column>
                    </template>
                </b-table>
            </div>

            <div
                style="
                    background: #f7f7f7;
                    padding: 20px;
                    margin: 40px;
                    text-align: center;
                    border-radius: 7px;
                "
                v-else
            >
                {{ $t("There is no data") }}
            </div>
        </div>

        <b-modal
            :active.sync="showAddCredit"
            trap-focus
            aria-role="dialog"
            aria-modal
            scroll="clip"
        >
            <add-credit-modal />
        </b-modal>
    </section>
</template>

<script>
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";
Vue.use(Viewer);
import moment from "moment";
import addCreditModal from "@/components/modal/addCreditModal.vue";
export default {
    components: {
        addCreditModal,
    },
    data() {
        return {
            options: {
                button: false,
                navbar: false,
                title: false,
                toolbar: false,
                tooltip: false,
            },
            showAddCredit: false,
            isPaginated: true,
            isPaginationSimple: false,
            paginationPosition: "bottom",
            defaultSortDirection: "asc",
            sortIcon: "arrow-up",
            sortIconSize: "is-small",
            currentPage: 1,
            perPage: 5,
            filterdTransaction: [],
            search: "",
            showImg: true,
            loading: false,
            current_index: 0,
            json_fields: {
                [this.$t("Transaction ID")]: "id",
                [this.$t("Date")]: {
                    field: "date",
                    callback: (value) => {
                        return moment(value).format("DD-MM-YYYY");
                    },
                },
                [this.$t("Amount") + " " + this.$t("SAR")]: {
                    field: "debit",
                    callback: (value) => {
                        let data =
                            this.transactions[this.current_index].credit -
                            value;
                        this.current_index++;
                        return data.toFixed(2);
                    },
                },
                [this.$t("Shipment tracking")]: "order_id",
                [this.$t("Description")]: "description",
            },
            json_meta: [
                [
                    {
                        key: "charset",
                        value: "utf-8",
                    },
                ],
            ],
        };
    },
    methods: {
        filterTransaction(page) {
            let filterString = `?page=${page ? page : 1}`;

            this.$store.dispatch("CREDIT_REQUEST_TRANSACTIONS", filterString);
        },
        resetIndex() {
            this.current_index = 0;
        },
    },
    watch: {
        search: {
            immediate: true,
            handler(val) {
                if (val) {
                    let query = new RegExp(val, "i");
                    this.filterdTransaction = this.transactions.filter((t) =>
                        query.test(`${t.transaction_id}`)
                    );
                } else {
                    this.filterdTransaction = this.transactions;
                }
            },
        },
        transactions: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.loading = false;
                    this.filterdTransaction = this.transactions;
                }
            },
        },
    },
    computed: {
        userData() {
            return this.$store.getters.userData;
        },
        transactions() {
            if (!this.$store.state.credit_transactions) return [];
            return this.$store.state.credit_transactions.data;
        },
        totalTransactions() {
            if (!this.$store.state.credit_transactions) return 0;
            return this.$store.state.credit_transactions.total;
        },
    },
    mounted() {
        this.$store.dispatch("userData");
        this.$store.dispatch("GET_BANKS");
        this.$store.dispatch("CREDIT_REQUEST_TRANSACTIONS", "");
    },
};
</script>

<style lang="scss">
#add_credit {
    .status {
        font-size: 12px;
        border-radius: 7px;
        padding: 2px 7px;
        color: #000;

        &.st-request {
            background: #4952ff70;
        }
    }

    .modal-add-credit {
        width: 100%;
        text-align: center;
        overflow: hidden;

        img {
            position: absolute;
            top: 3px;
            right: 0;

            &:lang(ar) {
                right: auto !important;
                left: 0;
            }
        }

        .main-modal {
            position: relative;
            display: inline-block;
            background-color: white;
            width: 945px;
            min-height: 600px;
            border-radius: 15px;

            @media screen and (max-width: 750px) {
                width: 100% !important;
            }
        }
    }

    .top_section {
        margin-top: 20px;
        margin-bottom: 60px;
        display: flex;
        justify-content: space-between;

        .baredex-credit {
            background-color: #4952ff;
            color: white;
            width: 325px;
            height: 200px;
            border-radius: 15px;
            padding: 25px 15px;
            display: inline-block;

            .credits {
                font-weight: bold;
                color: white;
                font-size: 2.4rem;
            }
        }
    }

    .balance {
        background: #f0f0f0;
        padding: 5px 20px;
        margin: 10px;
        align-items: center;
        display: flex;
        height: 50px;

        img {
            width: 70px;
        }

        span {
            font-size: 20px;
        }
    }

    .card-head {
        padding-top: 30px;

        div {
            display: flex;
            align-items: flex-end;

            &.l-sec {
                flex-wrap: wrap;
                justify-content: flex-start;

                input {
                    background: #f7f7f7;
                    width: 90%;
                    padding: 16px 50px;
                    border-radius: 50px;
                    outline: none;
                    font-size: 18px;
                    font-weight: bold;
                    color: #444;
                    letter-spacing: 0.7px;

                    &::placeholder {
                        color: #444;
                        font-size: 14px;
                        font-weight: lighter !important;
                    }
                }
            }

            &.r-sec {
                display: flex;
                justify-content: center;

                button {
                    margin: 10px;
                    height: 30px;
                    width: 130px;
                    border-radius: 7px;
                    padding: 0;
                    display: block;
                }
            }
        }
    }
}

.table-mobile-sort {
    display: none !important;
}

.d-sm-none {
    @media screen and (max-width: 750px) {
        display: none !important;
    }
}

.table {
    margin-top: 40px;
    padding: 0 5px;

    table {
        width: 100%;

        thead {
            background: #f7f7f7;
            border-radius: 5px;
        }

        th {
            padding-top: 11px;
            padding-bottom: 11px;
        }

        tbody {
            tr {
                border-bottom: 1px solid #ddd;
                height: 60px;

                td {
                    vertical-align: middle;
                }
            }
        }

        .total {
            font-weight: bold;
            text-align: center;
        }

        .primary {
            color: #4952ff;
            font-weight: bold;
        }

        .danger {
            color: #ff7977;
            font-weight: bold;
        }

        .text-center {
            text-align: center;
        }
    }
}

td {
    border-bottom: 2px solid #f7f8fa !important;
    vertical-align: middle;
}

.add-credit {
    background: #4952ff;
    border: none;
    border-radius: 3px;
    min-width: 120px;

    span {
        color: white !important;
    }
}

::v-deep {
    .is-centered {
        text-align: left !important;
    }

    .table {
        margin-top: 40px;
        padding: 0 30px;

        table {
            width: 100%;

            thead {
                background: #f7f7f7;
                border-radius: 5px;
            }

            th {
                padding-top: 11px;
                padding-bottom: 11px;
            }

            tbody {
                tr {
                    border-bottom: 1px solid #ddd;
                    height: 60px;
                    // &:last-of-type {
                    //     border: none;
                    // }
                }
            }

            .total {
                font-weight: bold;
                text-align: center;
            }

            .primary {
                color: #4952ff;
                font-weight: bold;
            }

            .danger {
                color: #ff7977;
                font-weight: bold;
            }

            .text-center {
                text-align: center;
            }
        }
    }
}
</style>
